import { render, staticRenderFns } from "./CodeTabs.vue?vue&type=template&id=6b6ad218&scoped=true&"
import script from "./CodeTabs.vue?vue&type=script&lang=js&"
export * from "./CodeTabs.vue?vue&type=script&lang=js&"
import style0 from "./CodeTabs.vue?vue&type=style&index=0&id=6b6ad218&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6ad218",
  null
  
)

export default component.exports